import React from "react";
import PropTypes from "prop-types";
import { translate } from "@td/shared_utils";
import { ParticipantItem, ParticipantsContainer } from "../../components";
import { participantTypes } from "../../constants";
import CreateParticipant from "../create-participant";
import { filter } from "lodash";

const Participants = ({ title, participants, participantType, onDelete }) => {
  const filteredParticipants = filter(participants, ["participantType", participantType]);

  return (
    <ParticipantsContainer>
      <h2 data-testid="participants-title">
        {title}
      </h2>
      {filteredParticipants.length> 0 ? (
        <table data-testid="participants-table">
          <thead>
            <tr>
              <th data-testid="participants-table-header">
                {translate(null, "practice_team.participants.list.headers", "name")}
              </th>
              <th data-testid="participants-table-header">
                {translate(null, "practice_team.participants.list.headers", "id")}
              </th>
              <th data-testid="participants-table-header">
                {translate(null, "practice_team.participants.list.headers", "type")}
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredParticipants.map((participant) => (
              <ParticipantItem
                key={participant.id}
                {...participant}
                onDelete={() => onDelete(participant.id)}
              />
            ))}
          </tbody>
        </table>
      ) : (
        <div data-testid="participants-message">
          {translate(null, "practice_team.participants.list.messages", "empty")}
        </div>
      )}

      {participantType === participantTypes.ADMIN && (
        <CreateParticipant
          participants={filteredParticipants}
        />
      )}
    </ParticipantsContainer>
  );
};

Participants.propTypes = {
  title: PropTypes.string.isRequired,
  participants: PropTypes.array.isRequired,
  participantType: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
};

Participants.displayName = "Participants";

export default Participants;
